import { render, staticRenderFns } from "./VueMagickPen.vue?vue&type=template&id=0ee0510a&scoped=true&v-slot%3Adefault=slotProps&"
import script from "./VueMagickPen.vue?vue&type=script&lang=js&"
export * from "./VueMagickPen.vue?vue&type=script&lang=js&"
import style0 from "./VueMagickPen.vue?vue&type=style&index=0&id=0ee0510a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee0510a",
  null
  
)

export default component.exports